<template>
  <div id="page-sector-view">
    <vx-card card-border class="mb-4" title="Detalle del sector" title-color="dark" collapseAction>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Empresa</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="sector.empresa.nombre" name="empresa_nombre" />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div class="vx-col w-full mb-3">
            <span>Sector inactivo/activo</span>
          </div>
          <div class="vx-col w-full">
            <vs-switch disabled vs-type="success" v-model="sector.activo"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Nombre</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="sector.nombre" name="nombre" />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Descripción</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="sector.descripcion" name="descripcion" />
          </div>
        </div>
      </div>
      
      <!-- Botóns -->
      <div class="vx-row" id="account-manage-buttons">
        <div class="vx-col sm:w-1/2 flex w-full">
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{ name: 'valSectoresEditar', params: { sectorId: $route.params.sectorId }}">Editar</vs-button>
          <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Borrar</vs-button>
        </div>
        <div class="vx-col sm:w-1/2 flex w-full justify-end">
          <vs-button color="warning" type="border" :to="{ name: 'valSectores' }">Cancelar</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import valSectoresStore from '@/store/configuracion/val-sectores/index.js'

export default {
  data () {
    return {
      sector: null
    }
  },
  computed: {
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmación de borrado',
        text: `¿Seguro que quiere eliminar el sector "${this.sector.nombre}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar'
      })
    },
    deleteRecord () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      this.$store.dispatch('valSectoresStore/deleteSector', this.sector.id)
        .then(()   => { this.$router.push({name:'valSectores'}); this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Sector eliminado',
        text: 'El sector ha sido eliminado'
      })
    }
  },
  created () {
    if (!valSectoresStore.isRegistered) {
      this.$store.registerModule('valSectoresStore', valSectoresStore)
      valSectoresStore.isRegistered = true
    }

    const sectorId = this.$route.params.sectorId
    const idx = this.$store.state.valSectoresStore.sectores.findIndex((u) => u.id == sectorId)
    this.sector = this.$store.state.valSectoresStore.sectores[idx]
  }
}

</script>